import { IAgoraRTCClient, useRTCClient } from "agora-rtc-react";
import { useEffect } from "react";

// Minimum quality floor for low-stream fallback
// Prevents "pixel-level" quality during network degradation (WiFi -> Cell)
// Previously used SDK defaults (~120-180p), now floors at 360p
const LOW_STREAM_CONFIG = {
  width: 480,
  height: 360,
  frameRate: 15,
  bitrate: 300, // kbps
};

export default function useAutoAdjustStreamQuality(rtcClient?: IAgoraRTCClient) {
  const client = useRTCClient(rtcClient);

  useEffect(() => {
    const setupDualStream = async () => {
      try {
        // Enable dual stream mode - allows clients to switch to low quality
        // profile when network quality cannot be satisfied
        await client.enableDualStream();

        // Configure low-stream parameters to prevent extreme quality drops
        // This sets a floor of 360p instead of SDK default (~120-180p)
        // Note: setLowStreamParameter is synchronous
        client.setLowStreamParameter(LOW_STREAM_CONFIG);
      } catch (error) {
        console.warn('Failed to configure dual stream mode', error);
      }
    };

    setupDualStream();
  }, [client]);
}
